import { Injectable, signal } from '@angular/core';
import { NodePickerEvent } from 'libs/shared/feature-flowchart/src/lib/infrastructure/operations/node-picker-toolbar/node-picker-toolbar-items.config';

export interface FlowchartDropEvent {
  elementType: NodePickerEvent;
  flowchartId: string;
  paperPosition: { x: number; y: number };
}

@Injectable({ providedIn: 'root' })
export class FlowchartDragDropService {
  public dragging = signal<NodePickerEvent | null>(null);
  public drop = signal<FlowchartDropEvent | null>(null);

  public startDrag(elementType: NodePickerEvent): void {
    this.dragging.set(elementType);
  }

  public endDrag(): void {
    this.dragging.set(null);
  }

  public emitDrop(event: FlowchartDropEvent): void {
    this.drop.set(event);
    this.endDrag();
  }
}
